/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 09/12/2022.
 */
import { GroupHeader } from '../../components/display/GroupHeader'
import { Button } from 'antd'
import React, { Suspense } from 'react'
import { Link, Route, Routes, useParams } from 'react-router-dom'
import { ProjectDrawer } from '../epro-project/ProjectDrawer'
import { formatDistance } from 'date-fns'
import { TrialStaffCRUD } from './TrialStaffCRUD'
import { useTrialStaff } from '../../hooks/useTrialStaff'
import { SpinnerFullHeight } from '../../components/spinner/SpinnerFullHeight'
import { AuditViewListTargetPersonnel } from '../audit/AuditViewListTargetPersonnel'
import { LoginViewListTrialStaff } from '../audit/LoginViewListTrialStaff'
import { AuditViewDetails } from '../audit/AuditViewDetails'
import { displayStaffStatus } from '../../util/staffUtils'

export const TrialStaff = () => {
  const { projectId } = useParams() as { projectId: string }
  const { data, mutate } = useTrialStaff(projectId)

  const closeDrawer = (value) => {
    if (!value) {
      mutate()
    }
  }

  const now = new Date()

  const deleteHeader = (
    <Link to="retire">
      <Button type="default">Change access</Button>
    </Link>
  )

  return (
    <>
      <Routes>
        <Route
          path="/create"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} setVisible={closeDrawer} to="../" title="Create a new trial staff">
                <TrialStaffCRUD closeDrawer={closeDrawer} viewType="CREATE"></TrialStaffCRUD>
              </ProjectDrawer>
            </Suspense>
          }
        />
        <Route
          path="/:userId/*"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer
                projectId={projectId}
                setVisible={closeDrawer}
                header={deleteHeader}
                to="../"
                title="View trial staff information"
              >
                <TrialStaffCRUD closeDrawer={closeDrawer} viewType="VIEW"></TrialStaffCRUD>
              </ProjectDrawer>
            </Suspense>
          }
        />
        <Route
          path="/:userId/:authorSub/audit-trail/*"
          element={
            <>
              <ProjectDrawer
                projectId={projectId}
                width="40%"
                to="../"
                title="View audit trail"
                header={
                  <div className="">
                    <Link to={'logins'} className="">
                      <Button type="default" className="me-2">
                        Logins
                      </Button>
                    </Link>
                  </div>
                }
              >
                <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                  <AuditViewListTargetPersonnel closeDrawer={closeDrawer} />
                  <Routes>
                    <Route
                      path="logins"
                      element={
                        <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                          <ProjectDrawer
                            width="50%"
                            projectId={projectId}
                            setVisible={closeDrawer}
                            to="../"
                            title="Login list"
                          >
                            <LoginViewListTrialStaff closeDrawer={closeDrawer} />
                          </ProjectDrawer>
                        </Suspense>
                      }
                    />
                    <Route
                      path="/:auditId"
                      element={
                        <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                          <ProjectDrawer
                            projectId={projectId}
                            width="30%"
                            setVisible={closeDrawer}
                            to="../"
                            title="Audit details"
                          >
                            <AuditViewDetails closeDrawer={closeDrawer} />
                          </ProjectDrawer>
                        </Suspense>
                      }
                    />
                  </Routes>
                </Suspense>
              </ProjectDrawer>
            </>
          }
        />
      </Routes>

      <div className="row mt-3 group-item" style={{}}>
        <GroupHeader
          label="Trial staff"
          header={
            <Link to={'./create'}>
              <Button type="primary">Create trial staff</Button>
            </Link>
          }
        >
          {data.map((item, index) => {
            return (
              <div key={index} className="col-12 py-3 border-bottom d-flex justify-content-between align-items-center">
                <div className="" style={{ width: '20%' }}>
                  <p className="p-mini">Name</p>
                  <div className="d-flex">
                    <p className="me-2">{item.name}</p>
                  </div>
                </div>

                <div className="" style={{ width: '25%' }}>
                  <p className="p-mini">Email</p>
                  <div className="d-flex">
                    <p className="text-truncate opacity-75">{item.email}</p>
                  </div>
                </div>

                <div className="d-flex justify-content-between" style={{ width: '15%' }}>
                  <div className="">
                    <p className="p-mini ">Type</p>
                    {item?.type}
                  </div>

                  <div className="me-4" style={{ width: '25%' }}>
                    <p className="p-mini ">Status</p>
                    <p className="">{displayStaffStatus(item)}</p>
                  </div>
                </div>

                <div className="d-flex justify-content-start" style={{ width: '10%' }}>
                  <div className="" style={{}}>
                    <p className="p-mini ">Invite sent</p>
                    {item.inviteSent ? (
                      <p className="text-primary">{formatDistance(now, new Date(item.inviteSent), {})}</p>
                    ) : (
                      'NOT SENT'
                    )}
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  <Link to={`./${item._id}/${item.sub}/audit-trail`}>
                    <Button className="me-2">Audit trail</Button>
                  </Link>

                  <Link to={'./' + item._id}>
                    <Button>View</Button>
                  </Link>
                </div>
              </div>
            )
          })}
        </GroupHeader>
      </div>
    </>
  )
}
